export const getTeamsState = state => state.teams;
